import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.implements_edit_page, .implements_new_page', async () => {
  const { default: Component } = await import(
    './internal/implements_edit_page__implements_new_page'
  );
  Component();
});
